import * as React from 'react';

import config from '../../config';
import { useSelector } from 'react-redux';
import { UserContext } from "../providers/UserProvider";
import { navigateTop } from '../routing/router-utils';
import BodyWrapper from '../layout/BodyWrapper';
import ProductTypes from './ProductTypes';
import PreviewMessage from '../preview/PreviewMessage';
import SignUpBar from '../footer/SignUpBar';
import ReorderBar from '../footer/ReorderBar';
import DispensariesList from '../dispensaries/DispensariesList';
import PickupDispensariesList from '../dispensaryPickup/PickupDispensariesList';
import { LayoutTypes } from '../layout/BodyWrapper';
import { getUrlHashedValue } from '../storage/storage-utils';
// import ResetNotifications from '../notifications/ResetNotifications';
import Helmet from 'react-helmet';

/**
 * The Web App Home page 
 * 
 * Purposely not including a style module for the page
 * All styling is in the children 
 */
const Home = () => {
  
  const { user, searchLocation, setSearchLocation } = React.useContext(UserContext);

  const isPickup = useSelector(state => state.is_pickup);

  React.useEffect(() => {
    if (window.location.hash && user?.isAnonymous && !searchLocation) {
      const address = getUrlHashedValue('address');
      if (address) {
        setSearchLocation(JSON.parse(window.atob(address)));
      }
    }
  }, [user, isPickup, searchLocation, setSearchLocation]);

  return (
    <>
      <Helmet>
        <title>Zip Run - Cannabis In-Store Pickup &amp; Delivery</title>
      </Helmet>
    
      <BodyWrapper pageLayout={LayoutTypes.Narrow}>
        {/* <ResetNotifications /> */}
        
        {/* TODO: Shop by Mood not implemented yet */}
        {/* window.tests_enabled && 
          <ShopByMood handleFilterClick={()=>{}} />
        */}

        { config.IS_PREVIEW_MODE &&
           <div style={{ paddingTop:'1rem'}}>
             <PreviewMessage />
           </div>
        }

        { isPickup  
          ? <PickupDispensariesList />  
          : <DispensariesList />
        }
      
        <ProductTypes handleFilterClick={(productType) => {
          navigateTop(`/shopByProduct/${productType}`);
        }} />

        { !config.IS_PREVIEW_MODE &&
          <>
            <SignUpBar />
            <ReorderBar />
          </>
        }

      </BodyWrapper>
    </>  
  );  
}

export default Home;